import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { ConfigService } from '../services/config.service'
import { AuthService } from '../services/auth.service'
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CatalogueGuard implements CanActivate {

  private loader$ = new Subject<boolean>();
  public loader = false;

  constructor(public authService: AuthService, public router: Router, public configService: ConfigService) {
    this.loader$.pipe(debounceTime(300)).subscribe(loader => { this.loader = loader});
  }

  async canActivate(): Promise<boolean> {
    console.debug("CatalogueGuard");
    this.setShowLoader(true)
    if (!this.configService.company_info) await this.configService.getLoadedCompany();

    try {
      await this.configService.getInitialInfo();
      var isLogged = await this.authService.checkAutentication();
      if(isLogged) await this.configService.getInitialInfo(true);
      var isPublic = this.configService.company_info.company_catalogue_public
    } catch (error) {
      this.setShowLoader(false)
      this.router.navigateByUrl('/autenticacion');
      return false
    }
    
    if (isPublic || isLogged){
      this.setShowLoader(false);
      return true
    }
    this.setShowLoader(false)
    this.router.navigateByUrl('/autenticacion');
    return false
  }  
  
  setShowLoader(show) {
    this.loader$.next(show);
  }
}
